import { render, staticRenderFns } from "./Cards.html?vue&type=template&id=f8738a22&external"
import script from "./Cards.js?vue&type=script&lang=js&external"
export * from "./Cards.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports